import { Utils } from '@genial/utils';

import { messageError, notificationChannelsData } from '../../utils';

import { OrderSectionProps } from '.';

export const createSectionOrderItems = (props: OrderSectionProps) => {
  const { orderDate, orderName, orderHash } = props;
  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : messageError;
  const orderDateFormatted = orderDate
    ? Utils.Mask.DateFormat(orderDate, 'HH:mm:ss - dd/MM/yyyy')
    : messageError;

  const orderChannels = notificationChannelsData({ order: { notification: props.notification } });

  const hasOrderOrigin = !!props?.interactionChannelAuditDetail as boolean;

  if (!hasOrderOrigin) {
    return [
      { testID: 'name', label: 'Nome da ordem', value: orderNameFormatted },
      { testID: 'channels', label: 'Canal de envio', value: orderChannels || messageError },
      { testID: 'date', label: 'Hora/data de Envio', value: orderDateFormatted },
    ];
  }

  const solicitationDate = props.interactionChannelAuditDetail.interactionChannelDate;

  return [
    { testID: 'name', label: 'Nome da ordem', value: orderNameFormatted },
    {
      testID: 'origin',
      label: 'Canal de solicitação',
      value: props.interactionChannelAuditDetail?.interactionChannelOption.channel || messageError,
    },
    {
      testID: 'solicitation-date',
      label: 'Data de solicitação',
      value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
    },
    {
      testID: 'solicitation-time',
      label: 'Horário de solicitação',
      value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
    },
    { testID: 'channels', label: 'Canal de envio', value: orderChannels || messageError },
    { testID: 'date', label: 'Hora/data de Envio', value: orderDateFormatted },
  ];
};
